import { ClassData } from '@models/class-data';
export class EventSlotGroup {
  id: number;
  createdAt?: Date;
  updatedAt?: Date;
  name?: string;
  description?: string;
  color?: string;
  constructor(json: ClassData<EventSlotGroup>) {
    this.id = +json.id;
    if (json.createdAt) {
      this.createdAt = new Date(json.createdAt);
    }
    if (json.updatedAt) {
      this.updatedAt = new Date(json.updatedAt);
    }
    this.name = json.name;
    this.description = json.description;
    this.color = json.color;
  }
}
